import React, {ReactElement, SVGProps} from 'react';
import cn from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

// Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.
interface ChartLineUpIconProps extends SVGProps<SVGSVGElement> {
  tooltip?: ReactElement | string;
}

export const ChartLineUpIcon: React.FC<ChartLineUpIconProps> = props => {
  return (
    <Tooltip title={props.tooltip ?? ''}>
      <svg
        {...props}
        className={cn(props.className, 'icon chart-line-up')}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512">
        <path d="M48 408C48 421.3 58.75 432 72 432H488C501.3 432 512 442.7 512 456C512 469.3 501.3 480 488 480H72C32.24 480 0 447.8 0 408V56C0 42.75 10.75 32 24 32C37.25 32 48 42.75 48 56V408zM344 128H456C469.3 128 480 138.7 480 152V264C480 277.3 469.3 288 456 288C442.7 288 432 277.3 432 264V209.9L320.1 320.1C311.6 330.3 296.4 330.3 287 320.1L207.1 241.9L144.1 304.1C135.6 314.3 120.4 314.3 111 304.1C101.7 295.6 101.7 280.4 111 271L191 191C200.4 181.7 215.6 181.7 224.1 191L304 270.1L398.1 176H344C330.7 176 320 165.3 320 152C320 138.7 330.7 128 344 128V128z" />
      </svg>
    </Tooltip>
  );
};
